import { gradientBorder } from "../../../helper/helper"
import ProjectInfo from "../../Projects/ProjectInfo/ProjectInfo"
import s from "../vision/vision.module.css"
// import j from "../../Projects/Ranking/Ranking.module.css"
import j from "./Project.module.css"
import { Link } from "react-router-dom";

export default function ({colorFondo}) {
  let borderImage = gradientBorder(colorFondo)

    return(
        <section id="projectList" className={j.section}>
            <div className={s.container}>
            <div className={s.visionContainer}><span className={s.vision}>Projects ranking</span></div>
            <span className={j.parraf}>Ranked list of the top projects in the Venom ecosystem.</span>
            <div className={s.parrafContainer}>
            <ProjectInfo i= {0} colorFondo= {colorFondo} url={"https://twitter.com/Venom_Soldiers"}  name={"Venom Soldiers"} twitterFollowers={"800"} img={"https://pbs.twimg.com/profile_images/1666121948768743439/P0dB3U2y_400x400.jpg"} hype={30000} />
            </div>
            </div>
            <Link to={"/projects"} style={borderImage} className={j.link}>Show More</Link>

        </section>
    )
}